import styled from 'styled-components';

import Tooltip from 'components/shared/Tooltip';
import { colors } from 'styles/theme/colors';
import { H2 } from 'styles/typography';
import InfoIconOutline from 'svg/InfoIconOutline';

type Props = {
  title: string;
  tooltipText: string;
};

export default function DashboardTitleWithTooltip({ title, tooltipText }: Props) {
  return (
    <TitleWrapper>
      <Title>{title}</Title>
      <Tooltip text={tooltipText} position='right'>
        <InfoIconOutline width={12} height={12} fill={colors.black50} style={{ marginLeft: 8 }} />
      </Tooltip>
    </TitleWrapper>
  );
}

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled(H2)`
  font-size: 20px;
  font-weight: var(--font-weight-bold);
  white-space: nowrap;
`;
